import { NetworkStatus } from '@cbridge-utils/network';
import { ISyntheticSymbolStore } from './symbolSynthetic.interface';

export const MAX_SYNTHETIC_SYMBOLS_COUNT = 500;

export const symbolSyntheticInitialState: ISyntheticSymbolStore = {
  data: {},
  sourceSymbolsData: {
    list: [],
    networkStatus: NetworkStatus.None,
  },
  filteredCount: 0,
  totalCount: MAX_SYNTHETIC_SYMBOLS_COUNT,
  networkStatus: NetworkStatus.None,
};
